pmSectionItemHasData